<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm" class="addOrder">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="厂商" prop="company_id">
            <company-select v-model="form.company_id" clearable @change="companyChange"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="MAC批次" prop="mac_batch_no" :key="form.company_id">
            <mac-batch-select v-model="form.mac_batch_no" :company-id="form.company_id" clearable prop="batch_no"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="型号" prop="model" :key="form.company_id">
            <model-select v-model="form.model" :company-id="form.company_id" clearable @change="createSequence"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SN前缀" prop="sn_prefix">
            <el-input v-model.trim="form.sn_prefix" clearable placeholder="手动输入前缀"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="流水号" prop="sequence_id">
            <el-input-number v-model="form.sequence_id" :min="1" :max="99999999" :step="1" placeholder="自动类推记录"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="授权数" prop="quantity">
            <el-input-number v-model="form.quantity" :precision="0" :step="1" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="序号" prop="number">
            <el-input-number v-model="form.number" :precision="0" :step="1" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input v-model.trim="form.remark" clearable placeholder="备注" :maxlength="128"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="macTitle">
        <p class="color-primary">个数</p>
        <p class="color-primary">步长</p>
        <p class="color-primary">起始MAC</p>
      </el-form-item>
      <el-row class="macInput">
        <el-form-item label="LAN" prop="lan_number">
          <el-form-item prop="lan_number">
            <el-input-number v-model="form.lan_number" :precision="0" :step="1" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item prop="lan_step">
            <el-input-number v-model="form.lan_step" :precision="0" :step="1" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item prop="lan_start">
            <el-input v-model.trim="form.lan_start" clearable placeholder="手动粘贴输入"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="WAN" prop="wan_number">
          <el-form-item prop="wan_number">
            <el-input-number v-model="form.wan_number" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wan_step">
            <el-input-number v-model="form.wan_step" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wan_start">
            <el-input v-model.trim="form.wan_start" clearable placeholder="手动粘贴输入"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="2.4G" prop="wifi2g_number">
          <el-form-item prop="wifi2g_number">
            <el-input-number v-model="form.wifi2g_number" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi2g_step">
            <el-input-number v-model="form.wifi2g_step" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi2g_start">
            <el-input v-model.trim="form.wifi2g_start" clearable placeholder="手动粘贴输入"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="5.8G" prop="wifi5g_number">
          <el-form-item prop="wifi5g_number">
            <el-input-number v-model="form.wifi5g_number" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi5g_step">
            <el-input-number v-model="form.wifi5g_step" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi5g_start">
            <el-input v-model.trim="form.wifi5g_start" clearable placeholder="手动粘贴输入"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="6G" prop="wifi6g_number">
          <el-form-item prop="wifi6g_number">
            <el-input-number v-model="form.wifi6g_number" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi6g_step">
            <el-input-number v-model="form.wifi6g_step" :precision="0" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item prop="wifi6g_start">
            <el-input v-model.trim="form.wifi6g_start" clearable placeholder="手动粘贴输入"></el-input>
          </el-form-item>
        </el-form-item>
      </el-row>
    </el-form>
    <template slot="customFooter">
      <el-button size="small" @click="dialogData.visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="confirm" :disabled="stopConfirm">确定</el-button>
    </template>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkMac,checkSN} from '@utils/validate'
  import CompanySelect from "@view/components/select/CompanySelect"
  import ModelSelect from "@view/components/select/ModelSelect"
  import MacBatchSelect from "@view/components/select/MacBatchSelect"
  export default {
    name: "AddOrder",
    props: {dialogData: Object},
    components: {CompanySelect,ModelSelect,MacBatchSelect},
    data() {
      let checkStartMac = (rule, value, callback) => {
        if (!value) return callback();
        let prop = rule.field;
        let list = ["lan_start","wan_start","wifi2g_start","wifi5g_start","wifi6g_start"];
        list.splice(list.indexOf(prop), 1);
        let item = list.find(item => this.form[item] === value);
        item ? callback(new Error('起始地址重复')) : callback();
      };
      let checkWifiStartMac = (rule, value, callback) => {
        if (!value) return callback();
        let lastChar = value.slice(-1).toLowerCase();
        if (lastChar !== '0' && lastChar !== '8') {
          return callback(new Error('起始MAC最后一位必须是0或8'));
        }
        callback();
      };
      return {
        oldSequence_id: "",
        form: {
          company_id: "",
          mac_batch_no: "",
          model: "",
          sequence_id: "",
          quantity: "",
          number: "",
          sn_prefix: "",
          remark: "",
          lan_number: "",
          lan_step: "",
          lan_start: "",
          wan_number: "",
          wan_step: "",
          wan_start: "",
          wifi2g_number: "",
          wifi2g_step: "",
          wifi2g_start: "",
          wifi5g_number: "",
          wifi5g_step: "",
          wifi5g_start: "",
          wifi6g_number: "",
          wifi6g_step: "",
          wifi6g_start: "",
        },
        rules: {
          company_id: [changeEmpty("厂商")],
          mac_batch_no: [inputEmpty("MAC批次")],
          model: [changeEmpty("型号")],
          sequence_id: [inputEmpty("流水号")],
          quantity: [inputEmpty("设备数量", ["blur", "change"])],
          number: [inputEmpty("序号", ["blur", "change"])],
          sn_prefix: [inputEmpty("SN前缀"),checkSN()],
          lan_number: [inputEmpty("LAN个数", ["blur", "change"])],
          lan_step: [inputEmpty("LAN步长", ["blur", "change"])],
          lan_start: [checkMac(),{validator: checkStartMac, trigger: 'blur'}],
          wan_number: [inputEmpty("WAN个数", ["blur", "change"])],
          wan_step: [inputEmpty("WAN步长", ["blur", "change"])],
          wan_start: [checkMac(),{validator: checkStartMac, trigger: 'blur'}],
          wifi2g_number: [inputEmpty("2.4G个数", ["blur", "change"])],
          wifi2g_step: [inputEmpty("2.4G步长", ["blur", "change"])],
          wifi2g_start: [checkMac(),{validator: checkStartMac, trigger: 'blur'}],
          wifi5g_number: [inputEmpty("5.8G个数", ["blur", "change"])],
          wifi5g_step: [inputEmpty("5.8G步长", ["blur", "change"])],
          wifi5g_start: [checkMac(),{validator: checkStartMac, trigger: 'blur'}],
          wifi6g_number: [inputEmpty("6G个数", ["blur", "change"])],
          wifi6g_step: [inputEmpty("6G步长", ["blur", "change"])],
          wifi6g_start: [checkMac(),{validator: checkStartMac, trigger: 'blur'}],
        },
        stopConfirm: false,
      }
    },
    methods: {
      companyChange() {
        this.form.model = "";
        this.form.mac_batch_no = "";
      },
      async createSequence(value, item) {
        if (item) {
          this.form.lan_number = item.lan_number || 0;
          this.form.wan_number = item.wan_number || 0;
          this.form.wifi2g_number = item.wifi2g_number || 0;
          this.form.wifi5g_number = item.wifi5g_number || 0;
          this.form.wifi6g_number = item.wifi6g_number || 0;
        }
        let company_id = this.form.company_id;
        let model = this.form.model;
        if (company_id && model) {
          let nv = {company_id, model};
          let res = await this.$Http.createSequence(nv);
          if (res?.data) {
            this.form.sequence_id = this.oldSequence_id = res.data.sequence_id;
          }
        }
      },
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            if ((nv.lan_number || nv.lan_step) && !nv.lan_start) return this.msgError("请输入LAN起始MAC");
            if ((nv.wan_number || nv.wan_step) && !nv.wan_start) return this.msgError("请输入WAN起始MAC");
            if ((nv.wifi2g_number || nv.wifi2g_step) && !nv.wifi2g_start) return this.msgError("请输入2.4G起始MAC");
            if ((nv.wifi5g_number || nv.wifi5g_step) && !nv.wifi5g_start) return this.msgError("请输入5.8G起始MAC");
            if ((nv.wifi6g_number || nv.wifi6g_step) && !nv.wifi6g_start) return this.msgError("请输入6G起始MAC");
            nv.sequence_id !== this.oldSequence_id && (nv.new_sequence_id = nv.sequence_id);
            let res = await this.$Http.addOrderMac(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.stopConfirm = true;
              setTimeout(()=>{
                this.stopConfirm = false
              }, 5000);
            }
          }
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .addOrder {
    .macTitle {
      /deep/ {
        .el-form-item__content {
          p {
            width: 100%;
            text-align: center;
            overflow: hidden;
          }
        }
      }
    }
    .macInput {
      /deep/ {
        .el-form-item__content {
          .el-form-item {
            width: 100%;
            &:nth-child(2) {
              margin-left: 15px;
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
</style>
